import type { PropsWithChildren, ReactNode } from 'react';
import { Search } from 'lucide-react';

interface FilterBarSearch {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder?: string;
}

interface FilterBarProps extends PropsWithChildren {
  /** Built-in search field. Omit for a filter-only bar. */
  readonly search?: FilterBarSearch;
  /** Trailing meta, e.g. a result count. */
  readonly meta?: ReactNode;
}

/** Search + filter controls + result count. Lives in the `toolbar` slot of {@link WorkspacePage}. */
export function FilterBar({ search, meta, children }: FilterBarProps) {
  return (
    <div className="forq-filter-bar">
      {search ? (
        <label className="forq-filter-bar__search">
          <Search size={15} />
          <input
            type="search"
            value={search.value}
            onChange={(event) => search.onChange(event.target.value)}
            placeholder={search.placeholder}
          />
        </label>
      ) : null}
      {children ? <div className="forq-filter-bar__controls">{children}</div> : null}
      {meta ? <span className="forq-filter-bar__meta">{meta}</span> : null}
    </div>
  );
}
